export default __webpack_public_path__ + "static/media/tick.681077f6.png";